import { environment } from '@env';
import { firstValueFrom } from 'rxjs';
import { SessionBase } from '@core/base/session-base';
import { CheckSessionResponse } from '@core/base/session-base.types';
import { logger } from "@services/logger/logger.service";
import { OfficeSubscription } from "@core/office/office-subscription/office-subscription";
import { HttpClient } from "@angular/common/http";

const SESSION_ENDPOINTS = {
    CHECK_SESSION: `${environment.office_api_host}/api/check-session`,
    LOGIN: `${environment.office_api_host}/api/login-start`,
    LOGOUT: `${environment.office_api_host}/api/logout-session`,
} as const

export class OfficeSessionService extends SessionBase implements SessionBase {
    constructor(
        private http: HttpClient,
        private subscription: OfficeSubscription,
    ) {
        super();
    }

    public async check(): Promise<boolean> {
        // let authState: boolean | undefined = await firstValueFrom(this.authState$);
        //
        // if (authState) return authState;

        try {
            const res = await firstValueFrom(
                this.http.post<CheckSessionResponse>(
                    `${SESSION_ENDPOINTS.CHECK_SESSION}/${this.sessionInfo.session_id}?device_hash=${this.sessionInfo.device_hash}`,
                    {}
                )
            );
            if (res.success) {
                const storedSessionId = this.sessionInfo.session_id;

                const checkedDeviceHash = res.session.device_hash;

                if (checkedDeviceHash !== this.sessionInfo.device_hash) {
                    this.sessionInfo.device_hash = checkedDeviceHash;
                    localStorage.setItem('device_hash', checkedDeviceHash);
                }

                this.sessionInfo = res.session;

                if (this.sessionInfo.session_id != storedSessionId) {
                    localStorage.setItem('session_id', this.sessionInfo.session_id);
                }

                logger.log('Session info: ', this.sessionInfo);

                this._sessionInfo$.next(this.sessionInfo);
                this.authState$.next(true);

                const subscription = await this.subscription.fetchSubscription(this.sessionInfo.session_id);
                logger.log('Subscription info: ', subscription);

                if (subscription.can_trial_add) {
                    this.subscription.fetchSubscribeTrial(this.sessionInfo.session_id)
                }

                return true;
            }

            this.authState$.next(false);
            return false;
        } catch (e) {
            this.authState$.next(false);
            logger.error(this.constructor.name, 'checkSuccess', 'false', 'log');
            return false;
        }
    }

    public async processCallback(): Promise<boolean> {
        await Office.onReady();
        Office.context.ui.messageParent(JSON.stringify({
            type: 'r2-copilot-login',
            isLoggedIn: true
        }));
        return false;
    }

    public async login(userHint?: string): Promise<string> {
        try {
            const url = new URL(`${SESSION_ENDPOINTS.LOGIN}`);

            url.searchParams.append('session_id', this.sessionInfo.session_id);
            url.searchParams.append('device_hash', this.sessionInfo.device_hash);
            url.searchParams.append('ui_locales', environment.default_locale);
            url.searchParams.append('state', location.origin + '/auth/callback');


            userHint ?
                url.searchParams.append('login_hint', userHint) :
                '';

            url.searchParams.append('redirect_uri', location.origin + '/auth/callback');

            return url.toString();
        } catch (e: unknown) {
            throw new Error('Login error: ' + e);
        }
    }

    public async logout(): Promise<void> {
        const url = new URL(`${SESSION_ENDPOINTS.LOGOUT}/${this.sessionInfo.session_id}`);

        try {
            await firstValueFrom<null>(this.http.post<null>(url.href, {}));
            localStorage.removeItem('session_id');
            localStorage.removeItem('device_hash');

            this.authState$.next(false);
        } catch (e) {
            logger.error(e)
        }
    }
}
